/* src/app/components/control-module/file-upload-element/file-upload-element.component.css */
.center {
}
.loader {
  margin: 0 auto;
  border: 2px solid var(--gray-100);
  border-top: 2px solid var(--navy-600);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=file-upload-element.component.css.map */
